import * as React from 'react';
import classnames from 'classnames';
import CreatableSelect from 'react-select/lib/Creatable';
import IndicatorsContainer from '../../common/reactSelect/IndicatorsContainer';

const UploadedMediaItem: React.SFC<any> = (props) => {
    if (props.isUploading) {
        return (
            <div className="uploading">
                <span className="uploading--title">Uploading</span>
                <span className="uploading--progress">
                    <span
                        className="uploading--progress-percentage"
                        style={{ width: `${props.uploadPercentage || 5}%` }}
                    ></span>
                </span>
            </div>
        );
    } else {
        const isActive =
            props.showMediaLibrary &&
            props.selectedMedias &&
            props.selectedMedias.value == props.value;
        return (
            <div
                className={classnames('uploaded', { active: isActive })}
                onClick={props.setSelectedMedia}
            >
                <i className="nx nx-close" onClick={props.onClose}></i>
                <span className="uploaded-image">
                    {props.mediaURL.includes('mp4') ||
                    props.mediaURL.includes('webm') ||
                    props.mediaURL.includes('ogg') ||
                    props.mediaURL.includes('webm') ||
                    props.mediaURL.includes('mov') ||
                    props.mediaURL.includes('avi') ||
                    props.mediaURL.includes('wnv') ? (
                        <video controls={false} autoPlay={false}>
                            <source src={props.mediaURL} type="video/mp4" />
                        </video>
                    ) : (
                        <img src={props.mediaURL} alt="mediaURL" />
                    )}
                </span>
                {!props.showMediaLibrary ? (
                    <span className="info media-library--filters">
                        <input
                            type="text"
                            className={classnames({
                                'media-error': props.error.title
                            })}
                            onChange={(e) =>
                                props.onTitleChange(e.target.value)
                            }
                            value={props.title}
                            placeholder="Title"
                        />
                        <CreatableSelect
                            className="filter react-select"
                            classNamePrefix="react-select"
                            value={props.selectedTags || null}
                            onChange={props.onTagSelect}
                            isSearchable
                            isMulti
                            placeholder="Search or create  tags"
                            options={props.tags}
                            maxMenuHeight={200}
                            components={{
                                IndicatorsContainer
                            }}
                        />
                    </span>
                ) : null}
            </div>
        );
    }
};

export default UploadedMediaItem;
